export default __webpack_public_path__ + "static/media/header-visuel-1.83879576.webp";